import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/dc-shared-web/src/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/use-env-context.js");
